// extracted by mini-css-extract-plugin
export default {"dividerContainer":"XSZkpUToD1jqWjwNhIOh","actionButtonsWrapper":"DNbiQh7O4KwWD7HvUtw6","divider":"KhSrOtimXKFS8MbFBbFa"};